module.exports = __webpack_public_path__ + "img/bg-element-arc.5b46ed6c.png";